import React from 'react'

import { AccordionContent, AccordionItem, AccordionTrigger } from '@/_components/ui/accordion'
import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

interface IFAQItemProps {
	question: string
	answer: string
	index: number
}

const AFaqItem: React.FC<IFAQItemProps> = ({ question, answer, index }) => (
	<AccordionItem value={`item-${index}`}>
		<AccordionTrigger className='border-b-[1px] text-base font-light hover:no-underline border-medante-purple-dark text-medante-purple-dark rounded-none'>
			{question}
		</AccordionTrigger>
		<AccordionContent>
			<div className='page_content reset_margins mt-5'>
				<p dangerouslySetInnerHTML={{ __html: sanitizeAndProcessHtml(answer) }} />
			</div>
		</AccordionContent>
	</AccordionItem>
)

export default AFaqItem
